/* unplugin-vue-components disabled */import { render } from "./SpeachConfigureTable.vue?vue&type=template&id=19284177&scoped=true&ts=true"
import script from "./SpeachConfigureTable.vue?vue&type=script&lang=ts"
export * from "./SpeachConfigureTable.vue?vue&type=script&lang=ts"

import "./SpeachConfigureTable.vue?vue&type=style&index=0&id=19284177&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19284177"]])

export default __exports__